import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '../../Util/Session/session.service';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmpDetailsService {

 constructor(
    private http: HttpClient,
    private session: SessionService,
  ) { 
    try{
      environment.API_URL = this.session.GetUserDetails().ApiUrl;
    }catch(e){}
  }

  EmpProfile_InfoDocDetails(Detail: any){
    return this.http.post<any>(environment.API_URL + `EmpProfile_InfoDocDetails/Load`, 
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }))
  }

  EmpProfile_Details(Detail: any){
    return this.http.post<any>(environment.API_URL + `EmpProfile_Details/Update`, 
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }))
  }

  ESS_EmpProfile_BankDetails(Detail: any){
    return this.http.post<any>(environment.API_URL + `ESS_EmpProfile_BankDetails/Update`, 
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }))
  }

  EmpProfile_CurrentAddressDetails(Detail: any){
    return this.http.post<any>(environment.API_URL + `EmpProfile_CurrentAddressDetails/Update`, 
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }))
  }

  EmpProfile_PermanentAddress(Detail: any){
    return this.http.post<any>(environment.API_URL + `EmpProfile_PermanentAddress/Update`, 
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }))
  }

  GetEmployeeDetails(Detail: any){
    return this.http.post<any>(environment.API_URL + `GetEmployeeDetails/Load`, 
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }))
  }

  EmpProfile_QualificationDetails(Detail: any){
    return this.http.post<any>(environment.API_URL + `EmpProfile_QualificationDetails/Update`, 
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }))
  }

  EmpProfile_NomineeDetails(Detail: any){
    return this.http.post<any>(environment.API_URL + `EmpProfile_NomineeDetails/Update`, 
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }))
  }
  EmpProfile_DependentDetails(Detail: any){
    return this.http.post<any>(environment.API_URL + `EmpProfile_DependentDetails/Update`, 
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }))
  }

  EmpProfile_DocumentDetails(Detail: any){
    return this.http.post<any>(environment.API_URL + `EmpProfile_DocumentDetails/Update`, 
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }))
  }
}
